import Form from '@rjsf/core';
import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import useRegisterOrderFormRef from '@/components/_hooks/useRegisterOrderFormRef';
import { SchemaFormRefSource } from '@/redux/slices/slice_types';
import { RJSFSchema } from '@rjsf/utils/lib/types';
import React, { MutableRefObject, useRef } from 'react';
import { ProfileDetailsFormHandleChange } from './OPJobProfileDetailsForm';

export interface BaseProps {
  formRef?: MutableRefObject<Form | null>;
  schema: RJSFSchema;
  inputs?: Record<string, any>;
  handleChange: ProfileDetailsFormHandleChange;
}

// If we want to register a form, we need to provide `jobId`
type Props = (
  | {
      register: true;
      jobId: number;
    }
  | { register: false }
) &
  BaseProps;

const JobOrderProfileForm: React.FC<Props> = (props) => {
  const { register, formRef, schema, inputs, handleChange } = props;
  const internalRef = useRef<any>(null);
  const ref = formRef ?? internalRef;
  useRegisterOrderFormRef(
    register
      ? {
          disabled: false,
          formRef: ref,
          key: `${SchemaFormRefSource.JOB_PROFILE_DETAILS_FORM}_${props.jobId}`
        }
      : { disabled: true }
  );

  const handleProfileSchemaFormSubmit = () => {
    return undefined;
  };

  return (
    <SchemaForm
      formRef={ref}
      tagName="div"
      schema={schema}
      formData={inputs}
      liveOmit
      onChange={(data) => {
        handleChange({ key: 'order_profile_inputs', value: data.formData });
      }}
      onSubmit={handleProfileSchemaFormSubmit}
    />
  );
};

export default JobOrderProfileForm;
